// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1fD5R","signatureButtonsRight":"ModalSign_signatureButtonsRight__1ZDZj"};